var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-container",class:[
    _vm.content.titlePosition === 'top' ? 'image-title-top' : '',
    _vm.device.isMobile ? 'image-container-mobile' : ''
  ],attrs:{"id":_vm.content.key}},[_c('div',{staticClass:"image-box",class:[
      _vm.content.hasBack === 1 ? 'image-box-has-back' : '',
      _vm.content.heightNoLimit === 1 ? 'image-box-no-limit-height' : ''
    ],attrs:{"id":((_vm.content.key) + "-1")}},[_c('el-image',{staticClass:"image",style:({
        maxWidth: _vm.content.maxWidth ? _vm.content.maxWidth + 'rem' : ''
      }),attrs:{"id":((_vm.content.key) + "-1-1"),"src":_vm.content.url,"preview-src-list":[_vm.content.url]},on:{"click":function (e) {
        _vm.findChapterFrom(e)
        e.stopPropagation()
      }}})],1),_c('p',{staticClass:"image-title",style:({
      fontFamily: _vm.content.titleStyle.fontFamily || '',
      fontSize: (_vm.content.titleStyle.fontSize + 'rem') || '',
      lineHeight: (_vm.content.titleStyle.lineHeight + 'rem') || '',
      textIndent: (typeof _vm.content.titleStyle.textIndent === 'string') ? _vm.content.titleStyle.textIndent :
        (typeof _vm.content.titleStyle.textIndent === 'number') ? (_vm.content.titleStyle.textIndent + 'rem') : '',
      fontWeight: _vm.content.titleStyle.fontWeight || '',
      textDecoration: _vm.content.titleStyle.underline === 1 ? 'underline' : '',
      fontStyle: _vm.content.titleStyle.fontItalic === 1 ? 'italic' : '',
      textAlign: _vm.content.titleStyle.textAlign || '',
      color: _vm.content.titleStyle.color || '',
      backgroundColor: _vm.content.titleStyle.backgroundColor || '',
    }),attrs:{"id":((_vm.content.key) + "-2")},domProps:{"innerHTML":_vm._s(_vm.content.title)}}),(_vm.content.subtitle)?_c('p',{staticClass:"image-title image-subtitle",attrs:{"id":((_vm.content.key) + "-3")}},[_vm._v(_vm._s(_vm.content.subtitle))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }